<section class="datasets-page" [class.datasets-page-embedded]="isEmbedded">
  @if (!isEmbedded) {
    <header class="page-header">
      <div class="page-heading">
        <span class="page-kicker">Gestión de datos</span>
        <h1>Importaciones de datos</h1>
        <p>Consulta el estado de tus archivos y crea una importación desde un modelo de datos.</p>
      </div>

      <a mat-flat-button color="primary" class="new-import-btn" [routerLink]="['/schemas']">
        <mat-icon>add</mat-icon>
        Nueva importación
      </a>
    </header>
  }

  <div class="files-body">
    @if (datasets; as datasets) {
      @if (!isEmbedded) {
        <div class="summary-grid" aria-label="Resumen de importaciones">
          <button
            type="button"
            class="summary-card summary-total"
            [class.is-selected]="statusFilter === 'all'"
            [attr.aria-pressed]="statusFilter === 'all'"
            (click)="setStatusFilter('all')">
            <span class="summary-icon"><mat-icon>folder_open</mat-icon></span>
            <span class="summary-copy">
              <strong>{{ datasets.length }}</strong>
              <small>Total de cargas</small>
            </span>
          </button>

          <button
            type="button"
            class="summary-card summary-active"
            [class.is-selected]="statusFilter === 'active'"
            [attr.aria-pressed]="statusFilter === 'active'"
            (click)="setStatusFilter('active')">
            <span class="summary-icon"><mat-icon>sync</mat-icon></span>
            <span class="summary-copy">
              <strong>{{ countByStatus(datasets, 'active') }}</strong>
              <small>En proceso</small>
            </span>
          </button>

          <button
            type="button"
            class="summary-card summary-success"
            [class.is-selected]="statusFilter === 'completed'"
            [attr.aria-pressed]="statusFilter === 'completed'"
            (click)="setStatusFilter('completed')">
            <span class="summary-icon"><mat-icon>check_circle</mat-icon></span>
            <span class="summary-copy">
              <strong>{{ countByStatus(datasets, 'completed') }}</strong>
              <small>Completadas</small>
            </span>
          </button>

          <button
            type="button"
            class="summary-card summary-error"
            [class.is-selected]="statusFilter === 'failed'"
            [attr.aria-pressed]="statusFilter === 'failed'"
            (click)="setStatusFilter('failed')">
            <span class="summary-icon"><mat-icon>error</mat-icon></span>
            <span class="summary-copy">
              <strong>{{ countByStatus(datasets, 'failed') }}</strong>
              <small>Con errores</small>
            </span>
          </button>
        </div>

        <div class="imports-card">
          <div class="imports-toolbar">
            <div class="toolbar-heading">
              <h2>Historial de importaciones</h2>
              <p>{{ datasets.length }} {{ datasets.length === 1 ? 'carga registrada' : 'cargas registradas' }}</p>
            </div>

            <label class="search-field">
              <mat-icon>search</mat-icon>
              <input
                type="search"
                placeholder="Buscar archivo, modelo o usuario"
                aria-label="Buscar importaciones"
                [(ngModel)]="searchText">
              @if (searchText) {
                <button type="button" class="clear-search" aria-label="Limpiar búsqueda" (click)="searchText = ''">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </label>
          </div>

          @if (filteredDatasets(datasets); as filtered) {
            @if (filtered.length) {
              <div class="files-table" role="table" aria-label="Importaciones de datos">
                <div class="table-header" role="row">
                  <span role="columnheader">Archivo</span>
                  <span role="columnheader">Modelo de datos</span>
                  <span role="columnheader">Operación</span>
                  <span role="columnheader">Estado</span>
                  <span role="columnheader">Fecha</span>
                  <span aria-hidden="true"></span>
                </div>

                <ul class="files-list">
                  @for (file of filtered; track file.id) {
                    <li>
                      <button type="button" class="file-row" (click)="openDetail(file)">
                        <span class="file-cell file-primary">
                          <span class="file-icon" [class.file-icon-xlsx]="file.file_type.toLowerCase() === 'xlsx'">
                            <mat-icon>{{ file.file_type.toLowerCase() === 'xlsx' ? 'table_chart' : 'description' }}</mat-icon>
                          </span>
                          <span class="file-copy">
                            <strong>{{ file.name || 'Sin nombre' }}</strong>
                            <small>{{ file.file_type.toUpperCase() }} · {{ getCreatedBy(file) }}</small>
                          </span>
                        </span>

                        <span class="file-cell schema-cell" [title]="getSchemaDisplay(file)">
                          {{ getSchemaDisplay(file) }}
                        </span>

                        <span class="file-cell operation-cell">
                          <mat-icon>{{ operationIcon(file.type) }}</mat-icon>
                          {{ operationLabel(file.type) }}
                        </span>

                        <span class="file-cell">
                          <span class="status-chip" [ngClass]="getStatusClass(file.validation_status)">
                            <mat-icon>{{ getStatusIcon(file.validation_status) }}</mat-icon>
                            {{ getStatusLabel(file.validation_status) }}
                          </span>
                        </span>

                        <span class="file-cell date-cell">{{ formatCreatedAt(file.created_at) || 'Sin fecha' }}</span>
                        <mat-icon class="row-chevron">chevron_right</mat-icon>
                      </button>
                    </li>
                  }
                </ul>
              </div>
            } @else if (datasets.length) {
              <div class="status-empty status-empty-filtered">
                <span class="empty-icon-wrap"><mat-icon>search_off</mat-icon></span>
                <h3>No encontramos importaciones</h3>
                <p>Prueba con otro término o muestra nuevamente todos los estados.</p>
                <button mat-stroked-button type="button" (click)="clearFilters()">Limpiar filtros</button>
              </div>
            } @else {
              <div class="status-empty">
                <span class="empty-icon-wrap"><mat-icon>cloud_upload</mat-icon></span>
                <h3>Aún no hay importaciones</h3>
                <p>Elige un modelo de datos para descargar su plantilla y cargar tu primer archivo.</p>
                <a mat-flat-button color="primary" [routerLink]="['/schemas']">Crear primera importación</a>
              </div>
            }
          }
        </div>
      } @else if (datasets.length) {
        <ul class="files-list compact">
          @for (file of pagedDatasets(); track file.id) {
            <li>
              <button
                type="button"
                class="file-row compact-row"
                (click)="openDetail(file)">
                <span
                  class="compact-icon"
                  [class.compact-icon-xlsx]="file.file_type.toLowerCase() === 'xlsx'">
                  <mat-icon>{{ file.file_type.toLowerCase() === 'xlsx' ? 'table_chart' : 'description' }}</mat-icon>
                </span>
                <span class="row-main">
                  <span class="status-chip compact-status" [ngClass]="getStatusClass(file.validation_status)">
                    {{ getStatusLabel(file.validation_status) }}
                  </span>
                  <span class="file-name">{{ file.name || 'Sin nombre' }}</span>
                  <span class="row-bottom">
                    <span class="file-user">{{ getCreatedBy(file) }}</span>
                    @if (file.created_at) {
                      <span class="meta-dot"></span>
                      <span class="file-date">{{ formatCreatedAt(file.created_at) }}</span>
                    }
                  </span>
                </span>
                <mat-icon class="row-chevron">chevron_right</mat-icon>
              </button>
            </li>
          }
        </ul>
      } @else {
        <div class="status-empty embedded-empty">
          <mat-icon class="embedded-empty-icon">inbox</mat-icon>
          <h3>Aún no hay cargas</h3>
          <p>Cuando envíes un archivo aparecerá aquí con su estado.</p>
        </div>
      }
    } @else {
      <div class="status-loading">
        <mat-icon class="loading-spin">sync</mat-icon>
        Cargando importaciones...
      </div>
    }
  </div>
</section>
